import { encode, decode } from 'js-base64';
import { safeDecodeURIComponent } from './url';
/**
 * base64解码
 * @param str 需要解码的base64字符串
 * @param needUrlDecode 是否需要URL解码
 * @returns
 */
export function base64Decode(str: string, needUrlDecode = true) {
  const decodeStr = decode(str);
  // 使用safeDecodeURIComponent尝试解码，如果解码失败则返回原始字符串
  return needUrlDecode ? safeDecodeURIComponent(decodeStr) : decodeStr;
}

/**
 * base64编码
 * @param str 编码内容
 * @returns
 */
export function base64Encode(str: string) {
  // 由于btoa只支持ASCII内容编码，所以先URL编码下转换成ASCII编码
  return encode(str);
}
